import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IConversation, IMessage } from '../../../api/types';

export interface IMessageFeedbackModalPayload {
    message: IMessage;
    conversation: IConversation;
}

interface IMessageFeedbackModalState {
    visible: boolean;
    payload?: IMessageFeedbackModalPayload;
}

const initialState: IMessageFeedbackModalState = {
    visible: false,
};

export const messageFeedbackModalSlice = createSlice({
    name: 'message-feedback-modal',
    initialState,
    reducers: {
        openMessageFeedbackModal(state, action: PayloadAction<IMessageFeedbackModalPayload>) {
            state.visible = true;
            state.payload = action.payload;
        },
        closeMessageFeedbackModal(state) {
            state.visible = false;
            state.payload = undefined;
        },
    },
});

export const { openMessageFeedbackModal, closeMessageFeedbackModal } = messageFeedbackModalSlice.actions;
